import React from 'react';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  GoogleMapProps,
  MarkerProps,
} from 'react-google-maps';
import { GOOGLE_API_KEY } from '../config/env';

export interface MapProps {
  mapProps: GoogleMapProps;
  markerProps: MarkerProps;
}

const Map = compose<MapProps, MapProps>(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.exp`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
  // @ts-ignore
)(({ markerProps, mapProps }: MapProps) => (
  <GoogleMap {...mapProps}>
    <Marker {...markerProps} />
  </GoogleMap>
));

export default Map;
